import { Modal } from 'antd';
import React from 'react';

import egImg from '@/shared/img/Bruno-serial-number-example.jpg';

const SerialNumberExampleModal = (props) => {
    return (
        <>
            <Modal
                title={null}
                open={props.visible}
                onCancel={() => props.onClose()}
                footer={null}
                className="base__modal egmodal"
                style={{ top: 20 }}
            >
                <div className="eg__title_big">Where to find the serial number:</div>
                {/* <div className='eg__desc'>
        Find your machine's specific serial number. It is on a sticker on your machine or on the registration form in the box.
      </div> */}
                <br />
                <div>
                    <img src={egImg} alt="eg" className="eg__img" />
                </div>
                <br />
                {}
            </Modal>
        </>
    );
};

export default SerialNumberExampleModal;
